// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8b9f9cbb","168":"ae7070ef","250":"4d441627","421":"1fab1195","583":"c9155ddf","601":"6bdce3b8","808":"e407a1b7","891":"6f186468","918":"227908dd"}[chunkId] + ".chunk.js";
};